// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessageComponent_errorMessage__2vLZ6","customError":"errorMessageComponent_customError__RrBl3"};